module.exports = __webpack_public_path__ + "static/PrintManagement-677d11356af5b7d72a794120bb65539c.jpg";